import React, { useState, useEffect } from 'react';
import { useGA4React } from 'ga-4-react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Divider, useMediaQuery, Typography, Link } from '@mui/material';
import PrimaryButton from '../ui/buttons/primaryButton';
import IconButton from '@mui/material/IconButton';

import { Document, Page, pdfjs } from 'react-pdf';
import pdfjsWorker from 'react-pdf/node_modules/pdfjs-dist/build/pdf.worker.entry';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Report } from '../../libs/loggers';
import { useSelector } from 'react-redux';
import { maxWidth } from '@mui/system';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

function PDFView(props) {
  const [open, setOpen] = useState(false);
  const [numPages, setNumPages] = useState(null);
  let ga4React = useGA4React();
  let page = window.location.pathname.replace(/^\/|\/$/g, '');
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const userId = useSelector((state) => state.submition.data?.userId);
  const submitionId = useSelector((state) => state.submition.submition?.submitionId);
  const stepper = useSelector((state) => state.stepper.value);

  const handleClickOpen = () => {
    const eventInfo = {
      action: 'view',
      category: 'document',
      description: 'view fund document',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: props,
      },
    };

    Report(eventInfo, userId, submitionId);

    ga4React.event('view', props.file, 'pdf');

    window.open(props.file, '_blank', 'noopener,noreferrer');
  };

  const handleClose = () => {
    const eventInfo = {
      action: 'click',
      category: 'document',
      description: 'close fund document',
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: props,
      },
    };
    Report(eventInfo, userId, submitionId);
    setOpen(false);
    ga4React.event('close', props.file, 'pdf');
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div>
      {props.buttonType && props.buttonType === 'Icon' ? (
        <IconButton color="primary" onClick={handleClickOpen} size="large">
          <props.icon />
        </IconButton>
      ) : (
        <PrimaryButton onClick={handleClickOpen}>
          {props.title || 'View more information'}
        </PrimaryButton>
      )}

      <Dialog maxWidth={'lg'} open={open} onClose={handleClose} fullScreen={true}>
        <DialogContent>
          <PrimaryButton onClick={handleClose}>Close Document</PrimaryButton>
          <DialogTitle sx={{ width: '1190px', margin: 'auto', pl: 0, pb: 1 }}>
            {props.title || 'View more information'}
          </DialogTitle>
          <Box display="flex" justifyContent="center">
            <Document
              file={{
                url: props.file,
              }}
              onLoadSuccess={onDocumentLoadSuccess}
              externalLinkRel={'_self'}
              externalLinkTarget={'_blank'}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <Box key={`page_${index + 1}`}>
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    scale={isMobile ? 0.45 : 2}
                    renderAnnotationLayer={true}
                    renderInteractiveForms={true}
                    renderMode={'canvas'}
                  />

                  {index + 1 !== numPages && <Divider sx={{ margin: 1 }} />}
                </Box>
              ))}
            </Document>
          </Box>
        </DialogContent>
        <DialogActions sx={{ m: 2 }}>
          <Typography>
            Having trouble viewing this document?{' '}
            <Link href={props.file} target="_blank">
              Click here
            </Link>
          </Typography>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PDFView;
